import { useLayoutEffect, useRef, useState } from "react";

// Shrinks text to fit maxW; below min it compresses glyphs so it never overflows.
export const FitText = ({ text, x, y, base, maxW, min, anchor = "middle", testId, prefix, prefixFill, ...style }) => {
  const pre = prefix ? <tspan fill={prefixFill} data-testid="shield-name-number">{prefix}{"\u2002"}</tspan> : null;
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    let live = true;
    const measure = () => live && ref.current && setWidth(ref.current.getComputedTextLength());
    measure();
    document.fonts?.ready.then(measure);
    return () => { live = false; };
  }, [text, prefix, base, style.fontFamily, style.fontWeight, style.letterSpacing]);
  const fit = width ? Math.min(base, (base * maxW) / width) : base;
  const size = Math.max(fit, min);
  const squeeze = fit < min;
  return (
    <>
      <text ref={ref} data-export-hide x="-9999" y="-9999" fontSize={base} visibility="hidden" {...style}>{pre}{text}</text>
      <text x={x} y={y} fontSize={size} textAnchor={anchor} data-testid={testId}
        {...(squeeze ? { textLength: maxW, lengthAdjust: "spacingAndGlyphs" } : {})} {...style}>
        {pre}{text}
      </text>
    </>
  );
};
